import React from "react";
import WithSubscribe from "./Hero/WithSubscribe";
import Advantages from "./Advantages";
import LatestBlogs from "../../LatestBlogs";
import Contact from "./Contact";
import WithAnalyze from "./Hero/WithAnalyze";
import {useTranslation} from "react-i18next";
import {RecordCheckerSummary} from "./RecordCheckerSummary";
import {RecordGeneratorSummary} from "./RecordGeneratorSummary";
import {EnterpriseDmarcSummary} from "./EnterpriseDmarcSummary";
import {PricingOptions} from "../common/PricingOptions";
import {FollowUs} from "./FollowUs";
import {Helmet} from "@dr.pogodin/react-helmet";
import appname from "../../../appname";
import {FAQ} from "../common/FAQ";
import {I18nService} from "../../../service/i18nService";

const HomePage = () => {
    const i18nService = new I18nService();
    const currentLang = i18nService.getLanguage();

    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get("variant");
    const {t} = useTranslation();

    const isVariantA = variantParam
        ? variantParam.toLowerCase() === "a"
        : false;

    const pricingPage = "https://dmarcflow.com/" + currentLang + "/pricing";

    const generateFAQSchema = (faqItems, currentLang) => {
        return {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqItems.map((item) => ({
                "@type": "Question",
                "name": item.question,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": item.answer
                }
            })),
            "inLanguage": currentLang
        };
    };

    const items = t("pages.home.faq.items", {returnObjects: true});
    const schema = generateFAQSchema(items, currentLang);
    const faqItems = t("pages.home.faq.items", {returnObjects: true});

    const mySelf = appname + '/' + currentLang;
    return (
        <>
            <Helmet htmlAttributes={{lang: currentLang}}>
                <title>{t('pages.home.meta.title')}</title>
                <meta name="description" content={t('pages.home.meta.description')}/>
                <meta name="robots" content="index, follow"/>
                <link rel="canonical" href={appname + '/' + currentLang}/>

                {/* Open Graph */}
                <meta property="og:title" content={t('pages.home.meta.ogTitle')}/>
                <meta property="og:description" content={t('pages.home.meta.description')}/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content={appname + '/' + currentLang}/>
                <meta property="og:image"
                      content="https://dmarcflow.com/dmarc-flow-logo.webp"/>

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content={t('pages.home.meta.title')}/>
                <meta name="twitter:description" content={t('pages.home.meta.description')}/>
                <meta name="twitter:image"
                      content="https://dmarcflow.com/static/media/dmarc-flow-logo.d39195463fda1d6e5352.png"/>

                {/* Language variants */}
                <link rel="alternate" hrefLang="en" href={appname + "/en"}/>
                <link rel="alternate" hrefLang="de" href={appname + "/de"}/>
                <link rel="alternate" hrefLang="x-default" href={appname}/>

                {/* Optional structured data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "DMARCFlow",
                        "url": {mySelf},
                        "description": t('pages.home.meta.description'),
                        "publisher": {
                            "@type": "Organization",
                            "name": "Ucar Solutions UG",
                            "url": "https://ucar-solutions.de",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://dmarcflow.com/static/media/dmarc-flow-logo.d39195463fda1d6e5352.png"
                            }
                        }
                    })}
                </script>

                {/* Product & Offer schema */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Product",
                        "name": "DMARCFlow",
                        "image": "https://dmarcflow.com/static/media/dmarc-flow-logo.d39195463fda1d6e5352.png",
                        "description": t('pages.home.meta.description'),
                        "brand": {
                            "@type": "Brand",
                            "name": "Ucar Solutions UG"
                        },
                        "offers": [
                            {
                                "@type": "Offer",
                                "priceCurrency": "EUR",
                                "price": "1.00",
                                "priceValidUntil": "2025-12-31",
                                "availability": "https://schema.org/InStock",
                                "url": pricingPage,
                                "name": "Personal Use Plan"
                            },
                            {
                                "@type": "Offer",
                                "priceCurrency": "EUR",
                                "price": "34.99",
                                "priceValidUntil": "2025-12-31",
                                "availability": "https://schema.org/InStock",
                                "url": pricingPage,
                                "name": "SMB Plan"
                            }
                        ]
                    })}
                </script>

                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            </Helmet>

            <main className={`container-fluid pt-5 bg-white ${isVariantA ? 'variant-a' : 'variant-b'}`}>
                {isVariantA ? <WithSubscribe/> : <WithAnalyze/>}
                <RecordCheckerSummary/>
                <RecordGeneratorSummary/>
                <EnterpriseDmarcSummary/>
                <PricingOptions/>
                <Advantages/>
                <LatestBlogs/>
                <Contact/>
                <FollowUs/>
                <FAQ faqItems={faqItems} title={t("pages.home.faq.title")}></FAQ>
            </main>
        </>

    )
        ;
};

export default HomePage;
